import {Box, Grid, Paper, Typography} from "@mui/material";
import moment from 'moment';
import FORMATS from "../constants/Formats";
import {useTranslation} from "react-i18next";

const QuizStats = ({startDate, questionIdx, numQuestions, score, attempts}) => {
    const {t} = useTranslation();

    const startDateObj = new Date(startDate);
    const startDateStr = moment(startDateObj).format(FORMATS.DATE_TIME);

    return (
        <Box sx={{m: 2}}>
            <Grid container spacing={1}>
                <Grid item xs={4}>
                    <Box display="inline-block">
                        <Paper elevation={3} sx={{p: 1}}>
                            <Typography variant="h5">{t("score")}: {score.toFixed(1)}</Typography>
                        </Paper>
                    </Box>
                </Grid>
                <Grid container item xs={4} justifyContent="center">
                    <Paper elevation={3} sx={{textAlign: "center", p: 1}}>
                        <Typography variant="h5">{t("question")} {questionIdx + 1}/{numQuestions}</Typography>
                        <Typography variant="h6">{t("attempts_remaining")}: {attempts}</Typography>
                    </Paper>
                </Grid>
                <Grid container item xs={4} justifyContent="flex-end">
                    <Box display="inline-block">
                        <Paper elevation={3} sx={{textAlign: "end", p: 1}}>
                            <Typography>{t("started_at")}: {startDateStr}</Typography>
                        </Paper>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}

export default QuizStats;